<template>
  <div id="share" class="login" ref="main" v-if="!$store.state.login">
    <p>登陆后即可分享好课，赚取提成</p>
    <router-link
      :style="setBgd"
      tag="div"
      :to="'/login?from=' + $route.fullPath"
      class="btn-primary"
    >前往登陆</router-link>
  </div>
  <div id="share" v-else ref="main">
    <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
      <Poster v-if="components.poster" v-on:dismiss="components.poster = false" :poster="poster" />
    </transition>
    <ShareGuide :isRefresh="false" v-if="components.share" @close="components.share = false" />
    <div class="tab">
      <div class="wrapper">
        <span class="block" ref="block" />
        <span v-if="course.poster" class="tab-item" @click="switchTab">分享海报</span>
        <span class="tab-item" @click="switchTab">分享链接</span>
      </div>
    </div>
    <div class="content animated" ref="content">
      <div class="card" v-if="data && data[tab]">
        <div class="item" v-for="item in data[tab]" :key="item.title">
          <div class="left">
            <i :style="setColor" :class="item.icon" />
          </div>
          <div class="right">
            <h3>{{ item.title }}</h3>
            <h4>{{ item.desc }}</h4>
          </div>
        </div>
      </div>
      <div :style="setBgd" class="btn-primary" @click="components.share = true" v-if="tab === 1">
        <i class="anyteachicon anyteach-ArtboardCopy" /> 如何分享
      </div>
      <div
        :style="setBgd"
        class="btn-primary"
        @click="components.poster = true"
        v-if="course.poster && tab === 0"
      >
        <i class="anyteachicon anyteach-shengcheng" /> 生成海报
      </div>
      <router-link tag="div" to="/me" class="btn-hint">更改姓名和头像</router-link>
    </div>
  </div>
</template>

<script>
import Poster from "./Poster"
import ShareGuide from "@/components/invite/refer/Share.vue"
import mixin from "./mixin"
export default {
  name: "Share",
  props: ["course", "color"],
  mixins: [mixin],
  components: {
    Poster,
    ShareGuide,
  },
  data() {
    return {
      tab: null,
      components: {
        poster: false,
        share: false,
      },
      data: null,
      poster: null,
    }
  },
  methods: {
    switchTab(e) {
      const className = "tab-item"
      const active = "active"
      const els = [...document.getElementsByClassName(className)]
      let element, index

      if (Number.isInteger(e)) {
        index = e
        element = els[index]
      } else {
        element = e.target
        index = els.indexOf(element)
      }

      if (this.tab === index) return

      els.forEach(el => el.classList.remove(active))
      const x = index * element.clientWidth
      this.$refs.block.style.transform = `translateX(${x}px)`
      this.$refs.content.classList.add("fadeIn")
      this.tab = index
      setTimeout(() => {
        if (element) {
          element.classList.add(active)
        }
      }, 100)
      setTimeout(() => {
        if (this.$refs.content) {
          this.$refs.content.classList.remove("fadeIn")
        }
      }, 500)
    },
    async getData() {
      try {
        const { value_1 } = await this.$api.api.CUSTOM("share_widget")
        this.data = JSON.parse(value_1)
        this.switchTab(0)
        this.$nextTick(() => {
          if (!this.$route.query.showShare) return
          const position = this.$refs.main.getBoundingClientRect()
          setTimeout(() => {
            window.scrollTo({
              top: position.top,
              left: 0,
              behavior: "smooth",
            })
          }, 800)
        })
      } catch (err) {
        throw new Error(err)
      }
    },
    async getPoster() {
      try {
        const res = await this.$api.course.POSTER({
          id: this.course.id,
          // qr_url: `${window.homePageUrl}${this.$route.path}?friend=${this.$store.state.user.user_id}`,
        })
        if (res) {
          this.poster = res
        }
      } catch (error) {
        throw new Error(error)
      }
    },
  },
  created() {
    if (this.$store.state.login) {
      this.getData()
      if (this.course.poster) {
        this.getPoster()
      }
    }
  },
}
</script>
<style lang="scss" scoped>
@import "../style.scss";
@import "@/assets/css/button.scss";

.login {
  p {
    padding-bottom: 5px;
  }
}
#share {
  text-align: center;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  padding: 15px 0;

  .btn-primary {
    background: $red;
    border-color: $red;
  }
}

.tab {
  display: inline-block;
  height: 30px;
  margin: 0 auto 15px auto;

  .wrapper {
    border-radius: 30px;
    background: #e6e6e6;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  span {
    width: 80px;
    height: 35px;
  }

  .block {
    border-radius: 50px;
    border: 1px solid #e6e6e6;
    position: absolute;
    background: white;
    top: 0;
    left: 0;
    transition: transform 0.3s;
    box-shadow: 0 0 20px -5px #cacaca;
  }

  .tab-item {
    z-index: 1;
    font-size: 0.8rem;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.1s;
    &:active {
      transform: scale(0.9);
    }
  }

  .active {
    font-weight: bold;
    &:active {
      transform: none;
    }
  }
}

.card {
  width: 90%;
  margin: auto 5%;
  margin-bottom: 15px;
  background: #f7f7f7;
  border-radius: 4px;
  padding: 10px 15px;
  text-align: left;

  &:last-child {
    margin-bottom: 0;
  }
  .item {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    &:last-child {
      margin-bottom: 0;
    }
    .left {
      padding-right: 10px;
      i {
        font-size: 35px;
        color: $red;
      }
    }
    .right {
      h3 {
        @include avenir-demi();
        font-size: 1rem;
      }
      h4 {
        @include avenir();
        font-size: 0.9rem;
        font-weight: 400;
        opacity: 0.6;
        line-height: 1.2;
      }
    }
  }
}
</style>
